import { Buttons } from './Buttons';

export const Headers = { Buttons };